import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import getLocation from "../../../helpers/geolocator";
import { config } from "../../../config/index";
import { to12Hr } from "../../../helpers/moment";
import { POST, PUT, GET, newFetch } from "../../../helpers/fetch";
import Modal from "react-modal";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";
import * as faceapi from "@vladmandic/face-api/dist/face-api.esm.js";
import FaceVerification from "./FaceVerification";

const { API_URL, LOCATION_API_URL, LOCATION_API_SECRET_KEY } = config;

const AssignedShift = ({
  history,
  activeDate,
  activeSchedules,
  activeSite,
  selectedSchedule,
  setSelectedSchedule,
  activeClient,
  circleRadius,
  isInsideCircle,
  distanceTo,
  showAllShifts,
}) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  const client_id = user.site_associates[0].site.client_id;
  const site_id = user.site_associates[0].site_id;

  const [schedule, setSchedule] = useState(null);
  const [replacement, setReplacement] = useState(null);
  const [activeReplacements, setActiveReplacements] = useState(null);
  const [activeReplacement, setActiveReplacement] = useState(null);
  const [mcUploaded, setMcUploaded] = useState(null);
  const [uploadExpiry, setUploadExpiry] = useState(null);
  // const [activeSchedule, setActiveSchedule] = useState(activeSchedules[0])
  const [status, setStatus] = useState(null);
  const [vto, setVTO] = useState(null);
  const [isActive, setIsActive] = useState(null);
  const [apiLocation, setApiLocation] = useState("");

  //to enable face verification, default value is true
  const [enableFaceVerification, setEnableFaceVerification] = useState(true);
  const videoRef = useRef();
  const [initializing, setInitializing] = useState(false);
  const [src, setSrc] = useState();
  const [imgSrc, setImgSrc] = useState();
  const [showModalFaceVerification, setShowModalFaceVerification] =
    useState(false);
  const [attendanceLogs, setAttendanceLogs] = useState([]);

  //show recent logs modal
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (showModal, id) => {
    setAttendanceLogs([]);
    fetchAttendanceLogs(id);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  //clock in / out modal
  const [type, setType] = useState(null);
  const [showModalClockInOut, setShowModalClockInOut] = useState(false);

  //geofencer
  const [kmDistance, setKMDistance] = useState("");
  const [showModalClockGeofencer, setShowModalClockGeofencer] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenModalClockInOut = async (type) => {
    const position = await getLocation();
    if (position.Long != 0) {
      const res = await fetch(
        LOCATION_API_URL +
          `${position.Long},${position.Lat}` +
          LOCATION_API_SECRET_KEY
      );
      const data = await res.json();
      if (data.features.length == 0) {
        setApiLocation("Location not found");
      } else {
        setApiLocation(data.features[0].place_name);
      }
    } else {
      ToastUtil.warning("Record will be saved without location");
      setApiLocation("User did not enable location data");
    }

    setType(type);
    setShowModalClockInOut(true);
    if (activeClient.enable_clockinout_facerecog) fetchSourceImage();
    setLoading(false);
  };
  const handleCloseModalClockInOut = () => setShowModalClockInOut(false);
  const [submitLabel, setSubmitLabel] = useState("Yes");
  const [disabled, setDisabled] = useState(false);

  const padding = 90; // adjust this to your needs
  let height = showModal ? 250 + padding : 150 + padding;
  let heightPx = height + "px";
  let heightOffset = height / 2;
  let offsetPx = heightOffset + "px";

  const style = {
    border: "0",
    borderRadius: "20px",
    bottom: "auto",
    height: heightPx, // set height
    left: "50%",
    padding: "2rem",
    position: "fixed",
    right: "auto",
    top: "40%", // start from center
    transform: "translate(-50%,-" + offsetPx + ")", // adjust top "up" based on height
    width: "80%",
  };

  const handleClockInGeofencer = async () => {
    setLoading(true);
    const position = await getLocation();
    if (position.Long != 0) {
      const point = [position.Lat, position.Long];
      const inside = isInsideCircle(
        circleRadius.center,
        point,
        circleRadius.radius
      );
      const distance = distanceTo(circleRadius.center, point);
      const km = distance / 1000;

      setKMDistance(km.toFixed(1) + " km");

      !inside && setShowModalClockGeofencer(true);
      inside && handleOpenModalClockInOut("clock in");
    }
  };

  const handleOpenModalFaceVerification = () => {
    const loadModels = async () => {
      const MODEL_URL = process.env.PUBLIC_URL + "/models";
      setInitializing(true);
      Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
        faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
      ]).then(startVideo);
    };
    if (imgSrc !== undefined && imgSrc.length > 0) {
      loadModels();
      setShowModalFaceVerification(true);
    } else {
      ToastUtil.error(
        `Face is not detected. Make sure you have uploaded your face id on the Associate Edit Profile or contact the admin.`
      );
    }
  };

  const isSelected = (schedule) => selectedSchedule === schedule;
  const setAccordion = async (id, sched) => {
    if (isActive == id) {
      await setIsActive(null);
      await setSelectedSchedule(null);
    } else {
      await setIsActive(id);
      await setSelectedSchedule(sched);
    }
  };

  const fetchAttendanceLogs = async (id) => {
    let api_path = `/associate/${user.id}/schedule/${id}/attendance_log`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let data = response.data;
      setAttendanceLogs(data);
    }
  };

  const isClockInOutButtonDisabled = (date, start_time) => {
    const current_time = moment().format("YYYY-MM-DD HH:mm");
    const event_start_time = moment(date + " " + start_time)
      .subtract(1, "hour")
      .format("YYYY-MM-DD HH:mm");
    return moment(current_time).isSameOrBefore(event_start_time);
  };

  const clockInOutButtonHide = (date, start_time) => {
    const current_time = moment().format("YYYY-MM-DD HH:mm");
    const event_start_time = moment(`${date} ${start_time}`)
      .add(24, "hour")
      .format("YYYY-MM-DD HH:mm");
    return moment(current_time).isSameOrAfter(event_start_time);
  };

  const startVideo = async () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function (stream) {
        const video = document.querySelector("video");
        if ("srcObject" in video) {
          videoRef.current.srcObject = stream;
          setSrc(stream);
        }
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
      });
  };

  const fetchSourceImage = async () => {
    const api_path = `/associate/${user.id}/site/${site_id}/img_source`;
    const response = await newFetch(GET, api_path);
    if (response.success) {
      let data = response.data;
      setImgSrc(data);
    } else {
      ToastUtil.error(response.message);
    }
  };

  //geolocator clock in
  const clockIn = async () => {
    setSubmitLabel("Submitting...");
    setDisabled(true);
    let data = {
      location: apiLocation,
      associate_ids: [user.id],
      schedule: selectedSchedule,
    };

    data =
      type == "clock in"
        ? {
            ...data,
            time_in: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    data =
      type == "clock out"
        ? {
            ...data,
            time_out: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    let api_path = `/associate/${selectedSchedule.schedule_id}/clockinout_update`;
    let response = await newFetch(PUT, api_path, data);
    if (response.success) {
      ToastUtil.success(response.message);
      window.location.reload();
    }
  };

  const fetchDocumentUpload = async () => {
    let url = `${API_URL}/associate/shift/${selectedSchedule.schedule_id}/document/has_uploaded`;

    try {
      let response = await fetch(url, {
        method: "GET",
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        setMcUploaded(responseData.data.uploaded);
        setUploadExpiry(
          moment(`${selectedSchedule.date} ${selectedSchedule.start_time}`).add(
            48,
            "hours"
          )
        );
      } else {
        setMcUploaded(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSchedule = async () => {
    let url = `${API_URL}/schedule/${selectedSchedule.schedule_id}`;

    try {
      let response = await fetch(url, {
        method: "GET",
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        setSchedule(responseData.data);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReplacement = async () => {
    let api_url = `/associate/myreplacementrequest`;

    let data = {
      date: moment(activeDate).format("YYYY-MM-DD"),
      site_id: activeSite,
    };

    try {
      let response = await newFetch(POST, api_url, data);

      if (response.success) {
        setReplacement(response.data);

        if (response.data.length > 0) {
          setActiveReplacement(response.data[0]);
        } else {
          setReplacement(null);
          setActiveReplacement(null);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const applyVTOHandler = async (vto_id) => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to apply for VTO for this shift?"
      )
    ) {
      let url = `${API_URL}/associate/vto/${vto_id}/apply`;

      try {
        let response = await fetch(url, {
          method: "POST",
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        let responseData = await response.json();

        if (response.ok) {
          ToastUtil.success(responseData.message);
          window.location.reload();
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const activeReplacementHandler = (schedule_id) => {
    let filtered = activeReplacements.find(
      (replacement) => replacement.schedule_id === parseInt(schedule_id)
    );
    setActiveReplacement(filtered);
  };

  const approveReplacementHandler = async () => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to accept replacement for this shift?"
      )
    ) {
      let schedule_id = activeReplacement.schedule_id;
      let original_associate_id = activeReplacement.original_associate;
      let url = `${API_URL}/associate/shift/${schedule_id}/replace/${original_associate_id}/accept`;

      try {
        let response = await fetch(url, {
          method: "POST",
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        let responseData = await response.json();
        if (response.ok) {
          ToastUtil.success(responseData.message);
          window.location.reload();
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const rejectReplacementHandler = async () => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to reject replacement for this shift?"
      )
    ) {
      let schedule_id = activeReplacement.schedule_id;
      let original_associate_id = activeReplacement.original_associate;
      let url = `${API_URL}/associate/shift/${schedule_id}/replace/${original_associate_id}/reject`;

      try {
        let response = await fetch(url, {
          method: "POST",
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        let responseData = await response.json();

        if (response.ok) {
          ToastUtil.success(responseData.message);
          window.location.reload();
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (activeDate && activeSite) fetchReplacement();
  }, [activeDate, activeSite]);

  useEffect(() => {
    if (selectedSchedule) {
      fetchSchedule();
      if (activeClient && activeClient.enable_br_upload === true) {
        fetchDocumentUpload();
      }
    } else {
      setSchedule(null);
      setMcUploaded(null);
    }
  }, [selectedSchedule]);

  useEffect(() => {
    setSelectedSchedule(null);
    setType(null);
  }, [activeDate]);

  useEffect(() => {
    if (replacement && replacement.length > 0) {
      let replacementData = replacement.filter(
        (replace) =>
          replace.schedule.date === moment(activeDate).format("YYYY-MM-DD")
      );
      setActiveReplacements(replacementData);
    } else {
      setActiveReplacements(null);
    }
  }, [replacement, activeDate]);

  return (
    <React.Fragment>
      <div className="container py-2">
        <div className="shadow-sm border-0 rounded preffered-shift-container bg-white">
          <div className="container pb-4">
            <h6 className="py-2">Assigned Shifts </h6>
            <div className="accordion" id="accordionItems">
              {activeSchedules.length > 0 ? (
                activeSchedules
                  .sort(
                    (a, b) =>
                      moment(a.start_time, "HH:mm:ss") -
                      moment(b.start_time, "HH:mm:ss")
                  )
                  .map((schedule, index) => (
                    <div
                      className="card btn-block"
                      key={index}
                      style={{ border: "0" }}
                    >
                      <button
                        className={
                          "accordion-button btn btn-block py-1 text-left rounded" +
                          (isSelected(schedule)
                            ? schedule.status === 1 ||
                              schedule.status === 2 ||
                              schedule.status === 3 ||
                              schedule.status === 4 ||
                              showAllShifts
                              ? " btn-outline-success"
                              : " btn-outline-danger"
                            : schedule.status === 1 ||
                              schedule.status === 2 ||
                              schedule.status === 3 ||
                              schedule.status === 4 ||
                              showAllShifts
                            ? " btn-outline-success"
                            : " btn-outline-danger") +
                          (schedule.status === 1 ||
                          schedule.status === 2 ||
                          schedule.status === 3 ||
                          schedule.status === 4 ||
                          showAllShifts
                            ? " active"
                            : "") +
                          (showAllShifts ? " collapsed" : "")
                        }
                        type="button"
                        data-toggle="collapse"
                        data-target={"#_" + schedule.schedule_id}
                        aria-expanded="false"
                        aria-controls={"_" + schedule.schedule_id}
                        onClick={() =>
                          setAccordion(schedule.schedule_id, schedule)
                        }
                        disabled={
                          schedule.status === 1 ||
                          schedule.status === 2 ||
                          schedule.status === 3 ||
                          schedule.status === 4 ||
                          showAllShifts
                            ? false
                            : true
                        }
                      >
                        {`${
                          schedule.shift ? schedule.shift : "Shift"
                        } (${to12Hr(schedule.start_time)} - ${to12Hr(
                          schedule.end_time
                        )})`}
                        {schedule.status === 1 ||
                        schedule.status === 2 ||
                        schedule.status === 3 ||
                        schedule.status === 4 ||
                        showAllShifts ? (
                          <i
                            className="fas fa-caret-up"
                            aria-hidden="true"
                            style={{ fontSize: "20px", float: "right" }}
                          ></i>
                        ) : (
                          <i
                            className="fas fa-caret-down"
                            aria-hidden="true"
                            style={{ fontSize: "20px", float: "right" }}
                          ></i>
                        )}
                      </button>
                      <div
                        id={"_" + schedule.schedule_id}
                        key={"_" + schedule.schedule_id}
                        className={
                          "collapse " +
                          (schedule.status === 1 ||
                          schedule.status === 2 ||
                          schedule.status === 3 ||
                          schedule.status === 4
                            ? "show"
                            : "")
                        }
                        data-parent=""
                      >
                        <div className="h-100">
                          <div
                            className="form-group"
                            style={{ marginTop: "40px" }}
                          >
                            {activeClient.enable_clockinout_smartscheduler &&
                              (!clockInOutButtonHide(
                                schedule.date,
                                schedule.start_time
                              ) ? (
                                <React.Fragment>
                                  <div className="row">
                                    <div className="col-6 pb-4 d-flex align-items-center justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-outline-brand ml-3 mr-2 btn-clockinout"
                                        style={{
                                          width: "100%",
                                          fontSize: "15px",
                                          fontWeight: "bold",
                                          minHeight: "45px",
                                          maxHeight: "60px",
                                        }}
                                        onClick={() =>
                                          activeClient.enable_geofencing
                                            ? handleClockInGeofencer()
                                            : handleOpenModalClockInOut(
                                                "clock in"
                                              )
                                        }
                                        disabled={
                                          loading ||
                                          isClockInOutButtonDisabled(
                                            schedule.date,
                                            schedule.start_time
                                          )
                                        }
                                      >
                                        {loading ? "Loading..." : "Clock In"}
                                      </button>
                                    </div>
                                    <div className="col-6 pb-4 d-flex align-items-center justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-outline-brand mr-3 ml-2 btn-clockinout"
                                        style={{
                                          width: "100%",
                                          fontSize: "15px",
                                          fontWeight: "bold",
                                          minHeight: "45px",
                                          maxHeight: "60px",
                                        }}
                                        onClick={() =>
                                          handleOpenModalClockInOut("clock out")
                                        }
                                        disabled={isClockInOutButtonDisabled(
                                          schedule.date,
                                          schedule.start_time
                                        )}
                                      >
                                        Clock Out
                                      </button>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col ml-4 mb-1">
                                      <p>
                                        <small style={{ fontSize: "75%" }}>
                                          Note: Clock In and Clock Out buttons
                                          will be enabled one hour before shift
                                          start.
                                        </small>
                                      </p>
                                    </div>
                                  </div>
                                </React.Fragment>
                              ) : (
                                ""
                              ))}
                            <div className="row" style={{ marginTop: "10px" }}>
                              <div className="col ml-4">
                                <div
                                  className="form-group"
                                  style={{ marginBottom: "-.5rem" }}
                                >
                                  <h6 style={{ fontSize: "13px" }}>
                                    Punched in :
                                  </h6>
                                </div>
                              </div>
                              <div className="col ml-2">
                                <div
                                  className="form-group"
                                  style={{ marginBottom: "-.5rem" }}
                                >
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      float: "left",
                                      fontWeight: "500",
                                      lineHeight: "1.2",
                                    }}
                                  >
                                    Status :{"  "}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      float: "left",
                                      fontWeight: "500",
                                      lineHeight: "1.2",
                                      marginLeft: "3px",
                                    }}
                                    className={
                                      (schedule.status === 1 ||
                                        schedule.status === 2) === true
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {schedule.status === 2
                                      ? "On Time"
                                      : schedule.status === 3
                                      ? "Late"
                                      : schedule.status === 4
                                      ? "Late Allowed To Work"
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row" style={{ fontSize: "14px" }}>
                              <div className="col ml-4">
                                <div className="form-group">
                                  <div style={{ fontSize: "13px" }}>
                                    {schedule
                                      ? schedule.time_in
                                        ? moment(
                                            schedule.time_in,
                                            "YYYY-MM-DD HH:mm"
                                          ).format("DD/MM/YYYY") +
                                          " " +
                                          to12Hr(
                                            moment(
                                              moment(
                                                schedule.time_in,
                                                "YYYY-MM-DD HH:mm"
                                              ).format("YYYY-MM-DD HH:mm:ss")
                                            ).format("HH:mm")
                                          ) +
                                          (schedule.time_out
                                            ? " - " +
                                              moment(
                                                schedule.time_in,
                                                "YYYY-MM-DD HH:mm"
                                              ).format("DD/MM/YYYY") +
                                              " " +
                                              to12Hr(
                                                moment(
                                                  moment(
                                                    schedule.time_out,
                                                    "YYYY-MM-DD HH:mm"
                                                  ).format(
                                                    "YYYY-MM-DD HH:mm:ss"
                                                  )
                                                ).format("HH:mm")
                                              )
                                            : "")
                                        : "-"
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                              <div className="col ml-2">
                                <div className="form-group">
                                  <div style={{ fontSize: "13px" }}>
                                    <div
                                      className="show-recent-logs"
                                      onClick={() =>
                                        handleOpenModal(
                                          showModal,
                                          schedule.schedule_id
                                        )
                                      }
                                    >
                                      Show Recent Logs
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {!activeClient.enable_clockinout_biometrics ? (
                              <div
                                className="row"
                                style={{ marginTop: "10px" }}
                              >
                                {schedule.time_in &&
                                schedule.timein_location ? (
                                  <div className="col ml-4">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "-.5rem" }}
                                    >
                                      <h6 style={{ fontSize: "13px" }}>
                                        Punched in location:{" "}
                                        {schedule.timein_location}
                                      </h6>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {schedule.time_out &&
                                schedule.timeout_location ? (
                                  <div className="col ml-2">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "-.5rem" }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "13px",
                                          float: "left",
                                          fontWeight: "500",
                                          lineHeight: "1.2",
                                        }}
                                      >
                                        Punched Out Location :
                                        {schedule.timeout_location}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="py-1">None</div>
              )}
            </div>

            {status &&
              ((status.id === 7 &&
                (status.reason === "Medical Leave" ||
                  status.reason === "Reported Sick" ||
                  status.reason === "Urgent Leave")) ||
                (status.id === 6 &&
                  (status.reason === "Medical Leave" ||
                    status.reason === "Reported Sick" ||
                    status.reason === "Urgent Leave"))) && (
                // && mcUploaded === false
                // && (moment() <= uploadExpiry)
                <React.Fragment>
                  <hr className="mt-4 mb-3" />
                  <h6 className="py-2">
                    Proof of Documentation (
                    {mcUploaded ? "Uploaded" : "Not Uploaded"})
                  </h6>
                  <button
                    className="btn btn-block btn-brand"
                    disabled={mcUploaded}
                    onClick={() =>
                      history.push(
                        `/upload-proof/${selectedSchedule.schedule_id}`
                      )
                    }
                  >
                    Upload
                  </button>
                </React.Fragment>
              )}

            {status &&
              (status.id === 1 ||
                status.id === 2 ||
                status.id === 3 ||
                status.id === 4) &&
              schedule &&
              schedule.vto &&
              schedule.vto.slots - schedule.vto.associates.length > 0 && (
                <React.Fragment>
                  <hr className="mt-4 mb-3" />
                  <h6 className="pt-2">Apply for VTO</h6>
                  <small>
                    {schedule.vto.slots - schedule.vto.associates.length} Slots
                    Remaining
                  </small>
                  <button
                    className="btn btn-block btn-brand mt-2"
                    onClick={() => applyVTOHandler(schedule.vto.id)}
                  >
                    Apply
                  </button>
                </React.Fragment>
              )}

            {activeReplacements && activeReplacements.length > 0 && (
              <React.Fragment>
                <hr className="mt-4 mb-3" />
                <h6 className="py-2">Replacement Request</h6>
                <select
                  name=""
                  id=""
                  className="form-select mb-2"
                  onChange={(e) => activeReplacementHandler(e.target.value)}
                >
                  {activeReplacements && activeReplacements.length > 0 ? (
                    activeReplacements.map((replacement) => (
                      <option
                        key={replacement.schedule_id}
                        value={replacement.schedule_id}
                      >
                        {replacement.shift.name
                          ? `${replacement.shift.name} (${to12Hr(
                              moment(replacement.shift.start_time, "HH:mm:ss")
                            )} - ${to12Hr(
                              moment(replacement.shift.end_time, "HH:mm:ss")
                            )})`
                          : `Shift ${to12Hr(
                              moment(replacement.shift.start_time, "HH:mm:ss")
                            )} - (${to12Hr(
                              moment(replacement.shift.end_time, "HH:mm:ss")
                            )})`}
                      </option>
                    ))
                  ) : (
                    <option value={0}>No replacement</option>
                  )}
                </select>
                {/* <input type="text" className="form-control mb-2" disabled value={replacement.shift.name ? `${replacement.shift.name} (${to12Hr(moment(replacement.shift.start_time, 'HH:mm:ss'))} - ${to12Hr(moment(replacement.shift.end_time, 'HH:mm:ss'))})` : `Shift ${to12Hr(moment(replacement.shift.start_time, 'HH:mm:ss'))} - (${to12Hr(moment(replacement.shift.end_time, 'HH:mm:ss'))})`} /> */}
                <button
                  className="btn btn-block btn-brand"
                  onClick={() => approveReplacementHandler()}
                >
                  Approve
                </button>
                <button
                  className="btn btn-block btn-outline-default"
                  onClick={() => rejectReplacementHandler()}
                >
                  Reject
                </button>
              </React.Fragment>
            )}

            {/* {selectedSchedule &&
            status &&
            status.id === 1 &&
            moment(
              `${selectedSchedule.date} ${selectedSchedule.start_time}`,
              'YYYY-MM-DD HH:mm:ss'
            ).isAfter(moment()) && (
              <React.Fragment>
                {selectedSchedule && status && status.id === 1 && (
                  <button
                    disabled={!selectedSchedule}
                    onClick={() =>
                      history.push(`/cancel/${selectedSchedule.schedule_id}`)
                    }
                    className="btn btn-light btn-block mt-4 rounded"
                  >
                    Cancel shift
                  </button>
                )}
              </React.Fragment>
            )} */}
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <div>
            <h5>Logs</h5>
          </div>
          <div
            className="pl-4 pt-2"
            style={{ overflowY: "auto", fontSize: "14px" }}
          >
            {attendanceLogs.length > 0 ? (
              attendanceLogs.map((log, index) => (
                <div className="pb-1" key={index}>
                  - {log.type == "checkin" ? "Clocked In" : "Clocked Out"} at{" "}
                  {to12Hr(
                    moment(
                      moment(log.punchtime, "YYYY-MM-DD HH:mm").format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    ).format("HH:mm")
                  )}
                </div>
              ))
            ) : (
              <div className="pt-2">No record found</div>
            )}
          </div>
          <button
            className="btn btn-brand btn-block mt-auto mt-4"
            onClick={handleCloseModal}
          >
            Close
          </button>
        </div>
      </Modal>
      <Modal
        ariaHideApp={false}
        isOpen={showModalClockInOut}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <div className="text-center">
            <h5>Are you sure you want to {type}?</h5>
            <label>
              {`${selectedSchedule?.shift ? selectedSchedule.shift : "Shift"} 
            (${to12Hr(selectedSchedule?.start_time)} - ${to12Hr(
                selectedSchedule?.end_time
              )})`}
              {/* //location here */}
            </label>
          </div>
          <div className="d-flex justify-content-center mt-auto pt-3">
            {activeClient && activeClient.enable_clockinout_facerecog ? (
              <button
                type="button"
                onClick={() => handleOpenModalFaceVerification()}
                className="btn btn-brand btn-block mt-auto m-3"
              >
                Yes
              </button>
            ) : (
              <button
                type="button"
                onClick={clockIn}
                className="btn btn-brand btn-block mt-auto m-3"
                disabled={disabled}
              >
                {submitLabel}
              </button>
            )}
            <button
              className="btn btn-brand btn-block mt-auto m-3"
              onClick={handleCloseModalClockInOut}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        ariaHideApp={false}
        isOpen={showModalClockGeofencer}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: style,
        }}
      >
        <div className="d-flex flex-column h-100">
          <div className="text-center">
            <h5>Sorry, It seems you are not on the site to clock in.</h5>
            <label>You are {`${kmDistance}`} away from the site.</label>
          </div>
          <div className="d-flex justify-content-center mt-auto pt-3">
            <button
              className="btn btn-brand mt-auto m-3"
              onClick={() => {
                setLoading(false);
                setShowModalClockGeofencer();
              }}
            >
              Okay
            </button>
          </div>
        </div>
      </Modal>
      <FaceVerification
        user={user}
        type={type}
        imgSrc={imgSrc}
        src={src}
        videoRef={videoRef}
        faceapi={faceapi}
        clockIn={clockIn}
        showModalFaceVerification={showModalFaceVerification}
        setShowModalFaceVerification={setShowModalFaceVerification}
        setShowModalClockInOut={setShowModalClockInOut}
      />
    </React.Fragment>
  );
};

export default withRouter(AssignedShift);
